import { render, staticRenderFns } from "./Imports.vue?vue&type=template&id=a181c97a&scoped=true&"
import script from "./Imports.vue?vue&type=script&lang=js&"
export * from "./Imports.vue?vue&type=script&lang=js&"
import style0 from "./Imports.vue?vue&type=style&index=0&id=a181c97a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a181c97a",
  null
  
)

export default component.exports